import { render, staticRenderFns } from "./TableAssets.vue?vue&type=template&id=0faef1de&"
import script from "./TableAssets.vue?vue&type=script&lang=js&"
export * from "./TableAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports